import { Component, OnInit, signal, inject, computed, ChangeDetectorRef, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule, FormsModule, Validators, FormControl, FormGroup, ValidationErrors, ValidatorFn, AbstractControl, AsyncValidatorFn,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { provideNativeDateAdapter } from '@angular/material/core';

import { MATERIAL_MODULES } from 'src/app/Common/material.config';
import { SHARED_IMPORTS, SHARED_DECLARATIONS } from 'src/app/Common/shared.config';

import { LoginService } from '../login/login.service';
import { ModalWindowService } from 'src/app/Common/modal-window/modal-window.service';
import { AlumnisService, IAlumnisRecord, IPsResponseFormat } from 'src/app/Common/services/alumnis.service';
import { CustomerService, ICustomerRecord } from 'src/app/Common/services/customer.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, first, from, map, of, switchMap } from 'rxjs';

// --------------------------------------------------------------------------
// const passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
//   const p1 = control.get('password_1')?.value;
//   const p2 = control.get('password_confirm')?.value;
//   return p1 === p2 ? null : { passwordMismatch: true };
// };

@Component({
  selector: 'registro',
  imports: [CommonModule, ReactiveFormsModule,
    // ...MATERIAL_MODULES,
    FormsModule,
    MatDatepickerModule, 
    MatTimepickerModule,
    ...SHARED_IMPORTS,
    // ...SHARED_DECLARATIONS
  ],
  providers: [
    provideNativeDateAdapter()
  ],
  templateUrl: './registro.html',
  styleUrl: './registro.scss',
})
export class Registro implements OnInit {
  private _router = inject(Router);
  private _cdr = inject(ChangeDetectorRef); // Inyecta el detector de cambios
  private _ModalWindowS = inject(ModalWindowService);
  private _LoginS = inject(LoginService);
  private _AlumniS = inject(AlumnisService);
  private _CustomerS = inject(CustomerService);

  public f_data = new FormGroup({
    dni: new FormControl<string>('', Validators.required),
    num_colegiado: new FormControl<string>('', Validators.required),
    
  });
  
  public f_usuario: FormGroup = new FormGroup({});

  public alumni_ok: WritableSignal<boolean> = signal(false);
  public loading: WritableSignal<boolean> = signal(false);
  public return_error: WritableSignal<number> = signal(0);
  public hidePassword: any;
  public hideConfirmPassword: any;

  // ==========================================================================
  // --------------------------------------------------------------------------
  ngOnInit(): void {

    this.alumni_ok.set(false);
    this.loading.set(false);
    this.hidePassword = true;
    this.hideConfirmPassword = true;  
    this.f_usuario = new FormGroup({
      nombre: new FormControl<string>('', {
        validators: Validators.required,
        asyncValidators: this._usuarioUnicoValidator,
        updateOn: 'blur'
      }),
      email: new FormControl<string>('', Validators.required),
      password: new FormGroup({
        password_1: new FormControl<string|null>('', [
          Validators.required, 
          Validators.minLength(8)
        ]),
        password_confirm: new FormControl<string|null>('', Validators.required)
      }, {
        validators: this._passwordMatchValidator
      }),
      id_alumni: new FormControl<number>(0, Validators.required),  // No mostrado por pantalla
      activo: new FormControl<number>(1, Validators.required)  // No mostrado por pantalla
    
    });
    this.f_data.reset();
    this.f_usuario.reset();

  }
  
  // --------------------------------------------------------------------------
  public cancel(): void {

    this._router.navigate(['/login']);
    this._cdr.detectChanges();

  }

  // --------------------------------------------------------------------------
  public checkAlumni(): void {
    this.alumni_ok.set(false);
    this.return_error.set(0);
    this.loading.set(true);
    this._cdr.detectChanges();

    this._AlumniS.checkAlumni({
      dni: <string>this.f_data.value.dni, 
      num_colegiado: <string>this.f_data.value.num_colegiado
    }).subscribe({
      next: (response:IAlumnisRecord[]) => {
        console.log(response);
        if ( response.length === 0 ) {
          this._ModalWindowS.showMessageError('No se ha encontrado un colegiado con esos datos');
          this.alumni_ok.set(false);
        } else {
          // this._ModalWindowS.showMessageInfo('Colegiado encontrado');
          this._AlumniS.value = response;
          
          this.f_usuario!.get('email')?.setValue(response[0].email);
          this.f_usuario!.get('id_alumni')?.setValue(response[0].id_alumnis);
          this.f_usuario!.get('activo')?.setValue(1);
          
          let ctrl_nombre = this.f_usuario!.get('nombre');
          if ( ctrl_nombre ) {
            ctrl_nombre.markAsTouched(); 
            ctrl_nombre.setValue(response[0].nombre);
          }
          this.alumni_ok.set(true);
          this.loading.set(false);
          this._cdr.detectChanges();
        }
      },
      error: (error:any) => {
        this.return_error.set(error.code); 
        this.alumni_ok.set(false);
        this.loading.set(false);
        this._cdr.detectChanges();
      },
      complete: () => {
        this.loading.set(false);
        this._cdr.detectChanges();
      }
    });
    
  }

  // --------------------------------------------------------------------------
  public registrarUsuario(): void {
    this.loading.set(true);
    this._cdr.detectChanges();

    const customer_record: ICustomerRecord = this._CustomerS.getDefaultValues();
    customer_record.nombre = <string>this.f_usuario!.value.nombre;
    // customer_record.descripcion = <string>this.f_data.value.descripcion;
    let decoded_password = <string>this.f_usuario!.get('password')?.value.password_1;
    customer_record.activo = 1;
    customer_record.email = <string>this.f_usuario!.value.email;
    customer_record.id_alumni = <number>this._AlumniS.value[0].id_alumnis;
    
    from(this._CustomerS.hashSHA256(decoded_password)).pipe(
      switchMap((sha256Hash: string) => {
        customer_record.password = sha256Hash;
        return this._CustomerS.save(customer_record);
      })
    ).subscribe({
      next: (response:any) => {
        console.log(response);
        if ( response === false ) {
          this._ModalWindowS.showMessageError('No se ha podido registrar el usuario');
          this.alumni_ok.set(false);
        } else {
          this._ModalWindowS.showMessageInfo('Benvingut!!<br />JA ETS MEMBRE DE <strong>ALUMNI CMAB</strong>')
          .subscribe({
            next:()=>{
              this._LoginS.submitLogin(customer_record.nombre, decoded_password).subscribe({
                next: (response:any) => {
                  console.log(response);
                  this._LoginS.onLoginOK(response);
                  this._router.navigate(['/home']);
                },
                error: (error:any) => {
                  this._ModalWindowS.showMessageError(error);
                  this.alumni_ok.set(false);
                  // this._cdr.detectChanges();
                },
                complete: () => {
                  this.loading.set(false);
                  this._cdr.detectChanges();
                }
              });
              this.alumni_ok.set(true);
            },
            
          });
            
        }

      },
      error: (error:any) => {
        this._ModalWindowS.showMessageError(error);
        this.alumni_ok.set(false);
        this._cdr.detectChanges();
      },
      complete: () => {
        this.loading.set(false);
        this._cdr.detectChanges();
      }
    })
  }

  // --------------------------------------------------------------------------
  public cancelCredenciales(): void {
    // Se ejecuta cuando cualquiera de los campos de f_data obtienen el focus
   
    this.alumni_ok.set(false);
    this.return_error.set(0);
    this.f_usuario.reset();
    this._cdr.detectChanges();
  
  }

  // --------------------------------------------------------------------------
  // --------------------------------------------------------------------------
  private _passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const p1 = control.get('password_1')?.value;
    const p2 = control.get('password_confirm')?.value;
    
    return p1 === p2 ? null : { passwordMismatch: true };
  
  };
  
  // --------------------------------------------------------------------------
  private _usuarioUnicoValidator: AsyncValidatorFn = (control: AbstractControl): Observable<ValidationErrors | null> => {
    const nombre = control.value;

    // Si no hay valor, el validador es válido (se suele usar Validators.required por separado)
    if (!nombre) {
      return of(null);
    }

    return this._CustomerS.readByNombre(nombre).pipe(
      // Transformamos la respuesta en el formato que Angular entiende
      map((response: ICustomerRecord|null) => {
        if (response === null ) return null;
        
        return typeof response.id_usuario !== 'undefined' && 
              response.id_usuario > 0 ? 
              { usuarioNoUnico: true } :
              null;
      }),
      // Es buena práctica atrapar errores de red para que el formulario no se bloquee
      catchError(() => of(null)),
      // Importante: los validadores asíncronos deben completarse
      first() 
    );

  };


}
